import React from 'react'
import ReactPlayer from 'react-player'
import { withLocalization, Text as TextType } from 'hocs/localization'
import Heading from 'elements/Heading'
import Text from 'elements/Text'
import logo from 'assets/images/logo.png'
import * as styles from './PartnerPrinting.scss'
import video from 'assets/videos/Epson-ReadyPrint-Final.mp4'
import { wrapper } from 'shared/apps/Loading/Loading.scss'

interface IProps {
  t: TextType,
  trackVideoPlay(): void,
}

console.log(video)

const PartnerPrinting: React.FC<IProps> = ({ t, trackVideoPlay }) => (
  <section className={styles.root}>
    <div className='container'>
      <div className='row'>
        <div className='col-md-12'>
          <div className={styles.content}>
            <img src={logo} className={styles.logo} width={245} height={50} />
            <Heading title={t('header')} size={2} styleType='sectionHeader' />
            <Text size='xLarge' smSize='large'>
              {t('description')}
            </Text>
          </div>
          <div className={styles.player}>
            <ReactPlayer onPlay={trackVideoPlay} controls={true} url={video} />
          </div>
        </div>
      </div>
    </div>
  </section>
)

export default withLocalization('home.main.partnerPrinting')(PartnerPrinting)
